import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import moment from 'moment'
import DateTime from 'react-datetime'
import includes from 'lodash/includes'
import isObject from 'lodash/isObject'
import FormatMoney from '../../Utils/FormatMoney'
import OrderActions from '../../Redux/OrderRedux'
import CategoryActions from '../../Redux/CategoryRedux'
import DownloadOrderDetailList from '../../Containers/Order/DownloadOrderDetailList'
import { currentBranch, currentRole } from '../../Utils/PrivilegeUtils'

class DetailList extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY'
    this.orderStatus = [
      { value: 'checkout', label: 'CHECKOUT' },
      { value: 'payment-pending', label: 'PENDING' },
      { value: 'payment-failed', label: 'FAILED' },
      { value: 'canceled', label: 'CANCELED' },
      { value: 'confirmed', label: 'CONFIRMED' },
      { value: 'expired', label: 'EXPIRED' }
    ]

    this.orderType = [
      { value: 'all', label: 'ALL' },
      { value: 'modem', label: 'MODEM' },
      { value: 'attraction', label: 'ATTRACTION' },
      { value: 'event', label: 'EVENTS', restriction: ['admin_travy', 'PH'] },
      { value: 'insurance', label: 'INSURANCE', restriction: ['admin_travy', 'PH'] },
      { value: 'inventory', label: 'E-COMMERCE', restriction: ['admin_travy'] },
      { value: 'esim', label: 'ESIM', restriction: ['admin_travy'] },
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.sourceType = [
      { value: '', label: 'ALL' },
      { value: 'ID', label: 'PASSPOD', restriction: ['admin_travy', 'PH'] },
      { value: 'AP', label: 'TRAVYPASS', restriction: ['PH'] }
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.payment_methods = [
      { value: '', label: 'ALL' },
      { value: 'bank-transfer', label: 'BANK TRANSFER' },
      { value: 'credit-card', label: 'CREDIT CARD', restriction: ['PH'] },
      { value: 'cod', label: 'COD', restriction: ['ID'] },
      { value: 'virtual-account', label: 'VIRTUAL ACCOUNT', restriction: ['PH'] },
      { value: 'DANA', label: 'DANA', restriction: ['PH'] },
      { value: 'gopay', label: 'GOPAY', restriction: ['PH'] },
      { value: 'ovo', label: 'OVO', restriction: ['PH'] },
      { value: 'kredivo', label: 'KREDIVO', restriction: ['PH'] },
      { value: 'shopeepay', label: 'SHOPEEPAY', restriction: ['PH'] },
      { value: 'qris', label: 'QRIS', restriction: ['PH'] }
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.insuranceIncluded = [
      { value: '', label: 'ALL' },
      { value: 'yes', label: 'YES' },
      { value: 'no', label: 'NO' }
    ]

    this.state = {
      showModal: null,
      filter: {
        code: '',
        page: 1,
        filterDate: false,
        from: moment().subtract(1, 'months'),
        until: moment(),
        status: '',
        type: 'all',
        embed: '',
        inventory_type: '',
        q: '',
        transaction_amount_from: null,
        transaction_amount_to: null
      }
    }
  }

  componentDidMount = () => {
    this._fetchOrder()
    this.props.getCategory()
  }

  _fetchOrder = (filter = { page: 1 }, event) => {
    if (event) event.preventDefault()
    let params = {
      ...this.state.filter,
      ...filter
    }
    if (this.state.filter.from && this.state.filter.until) {
      params.from = this.state.filter.from.format('Y-MM-DD')
      params.until = this.state.filter.until.format('Y-MM-DD')
    } else {
      params.from = null
      params.until = null
    }

    params.filterDate = null
    this.props.getOrderDetailList(params)
  }

  _specialFilterChange = (event, field) => {
    let filter = { ...this.state.filter }
    let value = event.target.value
    filter[field] = value
    this.setState({ filter })
  }

  _productTypeChange = (event) => {
    let filter = { ...this.state.filter }
    let value = event.target.value
    filter.type = value
    if (value !== 'modem') {
      if (filter.embed !== '') {
        filter.embed = ''
        this.setState({ filter })
      } else if (filter.inventory_type !== '') {
        filter.inventory_type = ''
        this.setState({ filter })
      }
    }
    this.setState({ filter })
  }

  _filterChange = (data, field) => {
    const uniq = ['page', 'filterDate', 'from', 'until']
    let filter = { ...this.state.filter }
    let val = null

    if (includes(uniq, field)) {
      if (field === 'from' || field === 'until') {
        if (isObject(data)) {
          val = data
        }
      } else {
        val = data
      }
    } else {
      val = data.target.value
    }

    filter[field] = val
    this.setState({ filter })
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter, page }
    this.setState({ filter })
    this._fetchOrder({ page })
  }

  _renderOrderModem = (modems) => {
    return (
      <table className='mb-3 table-bordered'>
        <thead>
          <tr>
            <th className='text-center'>Qty</th>
            <th className='text-center'>Start Date</th>
            <th className='text-center'>End Date</th>
            <th className='text-center'>Wifi Product</th>
            <th className='text-center'>Amount</th>
          </tr>
        </thead>
        <tbody>
          {
            modems.map((item, i) => (
              <tr key={i}>
                <td className='text-center'>{item.qty}</td>
                <td className='text-center'>{item.start_date}</td>
                <td className='text-center'>{item.end_date}</td>
                <td className='text-center'>{item.product.title}</td>
                <td className='text-center'>{ FormatMoney(item.amount) }</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    )
  }

  _renderOrderAttraction = (attractions) => {
    return (
      <table className='mb-3 table-bordered'>
        <thead>
          <tr>
            <th className='text-center'>Attraction Date</th>
            <th className='text-center'>Attraction Title</th>
            <th className='text-center'>Attraction Package Title</th>
            <th className='text-center'>Provider</th>
            <th className='text-center'>Base Price</th>
            <th className='text-center'>Quantity</th>
            <th className='text-center'>Amount</th>
          </tr>
        </thead>
        {
          attractions.map((item, i) => {
            switch (item.provider) {
              case 'KLOOK':
                return (
                  <tbody key={i}>
                    <tr>
                      <td className='text-center'>{ item.date }</td>
                      <td className='text-center'>{ item.attraction.title }</td>
                      <td className='text-center'>{ item.attraction_package.title }</td>
                      <td className='text-center'>KLOOK</td>
                      <td className='text-center'>{ `SGD ${item.attraction.base_price}` }</td>
                      <td className='text-center'>
                        <ul>
                          {
                            item.skus.map((item, i) => (
                              <li key={i}>
                                {`${item.quantity} ${item.title}`}
                              </li>
                            ))
                          }
                        </ul>
                      </td>
                      <td className='text-center'>{ FormatMoney(item.amount) }</td>
                    </tr>
                  </tbody>
                )
              case 'BMG':
                return (
                  <tbody key={i}>
                    <tr>
                      <td className='text-center'>{ moment(item.date).format(this.dateFormat) || '-' }</td>
                      <td className='text-center'>{ item.attraction.title }</td>
                      <td className='text-center'>{ item.attraction_package.title }</td>
                      <td className='text-center'>BMG</td>
                      <td className='text-center'>{ item.booking_response !== null ? ('SGD ' + item.booking_response.totalAmount) : '-' }</td>
                      <td className='text-center' style={{ width: '60px' }}>
                        <span>{ `${item.children} Children` }</span><br />
                        <span>{ `${item.adults} Adult` }</span><br />
                        <span>{ `${item.seniors} Senior` }</span>
                      </td>
                      <td className='text-center'>{ FormatMoney(item.amount) }</td>
                    </tr>
                  </tbody>
                )
              default:
                return null
            }
          })}

      </table>
    )
  }

  _renderOrderEvent = (events) => {
    return (
      <table className='mb-3 table-bordered'>
        <thead>
          <tr>
            <th className='text-center'>Qty</th>
            <th className='text-center'>Start Date</th>
            <th className='text-center'>End Date</th>
            <th className='text-center'>Ticket Name</th>
            <th className='text-center'>Insurance Package</th>
            <th className='text-center'>Insurance Price</th>
            <th className='text-center'>Amount</th>
          </tr>
        </thead>
        <tbody>
          {
            events.map((item, i) => (
              <tr key={i}>
                <td className='text-center'>{ item.qty }</td>
                <td className='text-center'>{ moment(item.start_date).format(this.dateFormat) }</td>
                <td className='text-center'>{ moment(item.end_date).format(this.dateFormat) }</td>
                <td className='text-center'>{ item.ticket_name }</td>
                {
                  item.order_detail_product_event_insurance
                    ? <td className='text-center'>
                      { item.order_detail_product_event_insurance.ticket_package.name }
                    </td>
                    : <td className='text-center'> - </td>
                }
                {
                  item.order_detail_product_event_insurance
                    ? <td className='text-center'>
                      { FormatMoney(item.order_detail_product_event_insurance.ticket_package.price) }
                    </td>
                    : <td className='text-center'> - </td>
                }
                <td className='text-center'>{ FormatMoney(item.amount) }</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    )
  }

  _renderOrderInsurance = (insurances) => {
    return (
      <table className='mb-3 table-bordered'>
        <thead>
          <tr>
            <th className='text-center align-middle'>Start Date</th>
            <th className='text-center align-middle'>End Date</th>
            <th className='text-center align-middle'>Package Name</th>
            <th className='text-center align-middle'>Insured</th>
            <th className='text-center align-middle'>Beneficiary</th>
            <th className='text-center align-middle'>Amount</th>
          </tr>
        </thead>
        <tbody>
          {
            insurances.map((item, i) => (
              <tr key={i}>
                <td className='text-center align-middle'>{ item.inseption_date || '-' }</td>
                <td className='text-center align-middle'>{ item.finish_date || '-' }</td>
                <td className='text-center align-middle'>{ item.travel_package.name || '-' }</td>
                <td>
                  <table className='table-bordered' style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th className='text-center'>Name</th>
                        <th className='text-center'>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        item.insured.length !== 0 ? item.insured.map((item, i) => (
                          <tr key={i}>
                            <td>{ item.CustName || '' }</td>
                            <td>{ item.Status || '' }</td>
                          </tr>
                        ))
                          : <tr>
                            <td colSpan='6'>-No Data--</td>
                          </tr>
                      }
                    </tbody>
                  </table>
                </td>
                <td>
                  <table className='table-bordered' style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Percentage</th>
                        <th>Relationship</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        item.beneficiary.length !== 0
                          ? item.beneficiary.map((item, i) => (
                            <tr key={i}>
                              <td>{ item.BeneficiaryName || '' }</td>
                              <td>{ item.BeneficiaryPercentage || '' }</td>
                              <td>{ item.BeneficiaryRelationship || '' }</td>
                            </tr>
                          ))
                          : <tr>
                            <td>-- No Data --</td>
                          </tr>
                      }
                    </tbody>
                  </table>
                </td>
                <td className='text-center align-middle'>{ FormatMoney(item.amount) || '-' }</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    )
  }

  _renderOrderInventory = (inventories) => {
    return (
      <table className='mb-3 table-bordered'>
        <thead>
          <tr>
            <th className='text-center align-middle'>SKU</th>
            <th className='text-center align-middle'>Qty</th>
            <th className='text-center align-middle'>Product Name</th>
            <th className='text-center align-middle'>Type</th>
            <th className='text-center align-middle'>Subtype</th>
            <th className='text-center align-middle'>Category</th>
            <th className='text-center align-middle'>Brand</th>
            <th className='text-center align-middle'>Amount</th>
          </tr>
        </thead>
        <tbody>
          {
            inventories.map((item, i) => (
              <tr key={i}>
                <td className='text-center align-middle'>{ item.inventory_item.sku_v || '-' }</td>
                <td className='text-center align-middle'>{ item.qty || '-' }</td>
                <td className='text-center align-middle'>{ item.inventory_item.inventory ? item.inventory_item.inventory.name : '-' }</td>
                <td className='text-center align-middle'>{ item.inventory_item.varian_size.name || '-' }</td>
                <td className='text-center align-middle'>{ item.inventory_item.varian_colour.name || '-' }</td>
                <td className='text-center align-middle'>{ item.inventory_item.inventory ? item.inventory_item.inventory.category.name : '-' }</td>
                <td className='text-center align-middle'>{ item.inventory_item.inventory ? item.inventory_item.inventory.brand.name : '-' }</td>
                <td className='text-center align-middle'>{ FormatMoney(item.amount) || '-' }</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    )
  }

  _renderOrderEsim = (esims) => {
    return (
      <table className='mb-3 table-bordered'>
        <thead>
          <tr>
            <th className='text-center align-middle'>Qty</th>
            <th className='text-center align-middle'>eSIM Name</th>
            <th className='text-center align-middle'>Data Size</th>
            <th className='text-center align-middle'>Day(s)</th>
            <th className='text-center align-middle'>Amount</th>
          </tr>
        </thead>
        <tbody>
          {
            esims.map((item, i) => (
              <tr key={i}>
                <td className='text-center align-middle'>{ item.qty || '-' }</td>
                <td className='text-center align-middle'>{ item.variant.esim.name ? item.variant.esim.name : '-' }</td>
                <td className='text-center align-middle'>{ item.variant.data_size ? item.variant.data_size : '-' }</td>
                <td className='text-center align-middle'>{ item.variant.day ? item.variant.day : '-' }</td>
                <td className='text-center align-middle'>{ FormatMoney(item.amount) || '-' }</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    )
  }

  render () {
    const { order, category } = this.props
    const { data_detail } = order

    if (currentRole() === 'admin_travy') {
      return <Redirect to={`/order`} />
    }

    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Order Detail List
              {
                (order.fetching || order.processing) &&
                <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            {
              currentRole() !== 'admin_travy' &&
              <button className='btn btn-primary' onClick={() => this._toggleModal('download-list')}>Download Detail List</button>
            }
          </div>
          <div className='title-block'>
            <p className='title-description'>Filter:</p>
            <form className='form-inline' onSubmit={(event) => this._fetchOrder(null, event)}>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Search</label>
                <input
                  style={{ width: '250px' }}
                  type='text' placeholder='Order Number / Email /Name'
                  className='form-control'
                  value={this.state.filter.q}
                  onChange={(event) => this._filterChange(event, 'q')}
                />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Amount From:</label>
                <input
                  style={{ width: '180px' }}
                  type='number'
                  placeholder='Input Amount'
                  className='form-control'
                  value={this.state.filter.transaction_amount_from || ''} onChange={(event) => this._filterChange(event, 'transaction_amount_from')} />
                <label className='control-label ml-2 mr-2'>To:</label>
                <input
                  style={{ width: '180px' }}
                  type='number'
                  placeholder='Input Amount'
                  className='form-control'
                  value={this.state.filter.transaction_amount_to || ''}
                  onChange={(event) => this._filterChange(event, 'transaction_amount_to')} />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Date Range:</label>
                <DateTime
                  value={this.state.filter.from}
                  closeOnSelect
                  onChange={(date) => this._filterChange(date, 'from')}
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                />
                <label className='control-label ml-2 mr-2'>To:</label>
                <DateTime
                  value={this.state.filter.until}
                  closeOnSelect
                  onChange={(date) => this._filterChange(date, 'until')}
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Status</label>
                <select className='form-control' value={this.state.filter.status} onChange={(event) => this._filterChange(event, 'status')}>
                  <option value=''>ALL</option>
                  {this.orderStatus.map((list, i) => (
                    <option key={i} value={list.value}>{list.label}</option>
                  ))}
                </select>
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Source</label>
                <select className='form-control' value={this.state.filter.code} onChange={(event) => this._filterChange(event, 'code')}>
                  {
                    this.sourceType.map((item, i) => (
                      <option key={i} value={item.value}>{item.label}</option>
                    ))
                  }
                </select>
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Product Type</label>
                <select className='form-control' value={this.state.filter.type} onChange={(event) => this._productTypeChange(event)}>
                  {
                    this.orderType.map((list, i) => (
                      <option key={i} value={list.value}>{list.label}</option>
                    ))
                  }
                </select>
              </div>
              {
                currentBranch() !== 'PH' &&
                this.state.filter.type === 'modem' &&
                  <div className='form-group mr-2 mb-3'>
                    <label className='control-label mr-2'>Insurance</label>
                    <select className='form-control' value={this.state.filter.embed} onChange={(event) => this._specialFilterChange(event, 'embed')}>
                      <option value=''>ALL</option>
                      <option value='yes'>Included</option>
                      <option value='no'>Excluded</option>
                    </select>
                  </div>
              }
              {
                this.state.filter.type === 'inventory' &&
                  <div className='form-group mr-2 mb-3'>
                    <label className='control-label mr-2'>Category</label>
                    <select className='form-control' value={this.state.filter.inventory_type} onChange={(event) => this._specialFilterChange(event, 'inventory_type')}>
                      <option value=''>ALL</option>
                      {
                        category.data.map((item, i) => (
                          <option key={i} value={item.id}>{item.name.toUpperCase()}</option>
                        ))
                      }
                    </select>
                  </div>
              }
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Payment Method</label>
                <select className='form-control' value={this.state.filter.payment_method} onChange={(event) => this._filterChange(event, 'payment_method')}>
                  {this.payment_methods.map((list, i) => (
                    <option key={i} value={list.value}>{list.label}</option>
                  ))}
                </select>
              </div>
              <div className='form-group mr-2 mb-2'>
                <button type='submit' className='btn btn-primary'>Apply Filter</button>
              </div>
            </form>
          </div>
        </header>
        <section className='section'>
          <div className='card'>
            {
              !(order.fetching || order.processing) && order.err &&
              <div className='alert alert-danger'>{order.err}</div>
            }
            <div className='card-block'>
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='text-center'>Order Number</th>
                    <th className='text-center'>Confirmation Date</th>
                    <th className='text-center'>Status</th>
                    <th className='text-center'>Name</th>
                    <th className='text-center'>Phone Number</th>
                    <th className='text-center'>Email</th>
                    <th className='text-center'>Create Date</th>
                    <th className='text-center'>Payment Method</th>
                    <th className='text-center'>Currency</th>
                    <th className='text-center'>Total Deposit</th>
                    <th className='text-center'>Admin Fee</th>
                    <th className='text-center'>Total Amt</th>
                    <th className='text-center'>Discount Amt</th>
                    <th className='text-center'>Final Amt</th>
                    <th className='text-center'>Detail</th>
                  </tr>
                </thead>
                <tbody>
                  {!data_detail.data || !data_detail.data.length
                    ? <tr>
                      <td colSpan='15' className='text-center'>- No Data -</td>
                    </tr>
                    : data_detail.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center align-middle'>{ item.order_number }</td>
                        <td className='text-center align-middle'>
                          {
                            item.confirm_date !== null
                              ? moment(item.confirm_date).format(this.dateFormat)
                              : '-'
                          }
                        </td>
                        <td className='text-center align-middle'>{ item.status || '-' }</td>
                        <td className='text-center align-middle'>{ (item.salutation + ' ' + item.first_name + ' ' + item.last_name) }</td>
                        <td className='text-center align-middle'>{ item.phone_number || '-' }</td>
                        <td className='text-center align-middle'>{ item.email || '-' }</td>
                        <td className='text-center align-middle'>{ moment.unix(item.created_at).format(this.dateFormat) || '-' }</td>
                        <td className='text-center align-middle'>
                          {
                            (item.order_payments && item.order_payments.length > 0)
                              ? item.order_payments[0].payment_method
                              : '--No Data--'
                          }
                        </td>
                        <td className='align-middle text-center align-middle'>{ item.currency_code || '-' }</td>
                        <td className='align-middle text-center'>
                          { FormatMoney(item.total_deposit_amount) }
                        </td>
                        <td className='align-middle text-center'>
                          { FormatMoney(item.total_admin_fee) }
                        </td>
                        <td className='align-middle text-center'>
                          { FormatMoney(item.total_amount) }
                        </td>
                        <td className='align-middle text-center'>
                          { FormatMoney(item.discount_amount) }
                        </td>
                        <td className='align-middle text-center'>
                          { FormatMoney(item.final_amount) }
                        </td>
                        <td>
                          { item.modems.length !== 0 && this._renderOrderModem(item.modems) }
                          { item.attractions.length !== 0 && this._renderOrderAttraction(item.attractions) }
                          { item.events.length !== 0 && this._renderOrderEvent(item.events) }
                          { item.insurances.length !== 0 && this._renderOrderInsurance(item.insurances) }
                          { item.inventories.length !== 0 && this._renderOrderInventory(item.inventories) }
                          { item.esim.length !== 0 && this._renderOrderEsim(item.esim) }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section className='text-center'>
          {
            (data_detail && data_detail.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={data_detail.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={data_detail.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

        <Modal open={this.state.showModal === 'download-list'} onClose={this._toggleModal} closeOnOverlayClick>
          <DownloadOrderDetailList closeModal={() => this._toggleModal()} />
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order,
  category: state.category
})

const dispatchToProps = (dispatch) => ({
  getOrderDetailList: (filter) => dispatch(OrderActions.orderDetailListRequest(filter)),
  getCategory: () => dispatch(CategoryActions.getCategoryRequest())
})

export default connect(stateToProps, dispatchToProps)(DetailList)



// WEBPACK FOOTER //
// ./src/Pages/Order/DetailList.js